import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: './modules/auth/auth.module#AuthModule' },
  { path: 'logout', loadChildren: './modules/auth/auth.module#AuthModule' },
  { path: 'approvals', loadChildren: './modules/approval/approval.module#ApprovalModule' },
  { path: 'mypos', loadChildren: './modules/po/po.module#PoModule' },
  { path: 'poinfo', loadChildren: './modules/po/pages/poinfo/poinfo.module#PoinfoPageModule' },
  { path: 'po-line-item', loadChildren: './modules/po/pages/po-line-item/po-line-item.module#PoLineItemPageModule' },
  { path: 'dashboard', loadChildren: './modules/dashboard/pages/dashboard/dashboard.module#DashboardPageModule' },
  { path: 'receivingpo', loadChildren: './modules/po/pages/receivingpo/receivingpo.module#ReceivingpoPageModule' }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
